import { render, staticRenderFns } from "./versionPriceMobile.vue?vue&type=template&id=39e07072&scoped=true&"
import script from "./versionPriceMobile.vue?vue&type=script&lang=js&"
export * from "./versionPriceMobile.vue?vue&type=script&lang=js&"
import style0 from "./versionPriceMobile.vue?vue&type=style&index=0&id=39e07072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e07072",
  null
  
)

export default component.exports